/**
 * The constraint-rule "language": a small AST for the quantified, symbolic form
 * of each constraint class, plus the concrete rules for this model.
 *
 * Roadmap (this folder will grow):
 *   1. render a rule as a string            — ruleToString            [done]
 *   2. rule AST + toString                  — ruleAst.ts              [done]
 *   2b. relation schema + validation        — schema.ts, validate.ts  [done]
 *   3. evaluate the AST against the data     — interpret.ts            [done]
 *   4. parse the syntax back into the AST    — parse.ts                [done]
 *   5. edit rules live in the UI             — ruleSet.ts + the        [done]
 *                                              elements panel
 *   6. edit them with the tools a language   — diagnostics.ts,         [done]
 *      deserves: highlighting, squiggles,      service.ts, and the
 *      completion, go to definition           Monaco adapter in
 *                                             components/editor
 */

export * from './ruleAst';
export * from './schema';
export * from './validate';
export * from './naming';
export * from './interpret';
export * from './buildData';
export * from './constraintRules';
export * from './parse';
export * from './ruleSet';
export * from './diagnostics';
export * from './service';
export * from './types';
